import { Link } from "react-router-dom";

export interface CrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: CrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
      <Link to="/" className="cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-background-400" aria-hidden="true"></i>
          {item.to ? (
            <Link to={item.to} className="cursor-pointer hover:text-primary-600 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}